import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toastWarn } from '../../actions/toast';
import { LOGO_MAX_FILE_SIZE_IN_MB, LOGO_MIME_TYPES } from '../../constants';
import { useFileUpload } from '../../helpers/file-upload';
import { useOrganization } from './context/OrganizationContext';

const LogoUpload = () => {
    const { organizationState: state, setOrganizationState: handleChange } = useOrganization();
    const { uiConfig } = state;
    const [file, selectFile] = useFileUpload();

    const dispatch = useDispatch();

    const handleFileChange = (file) => {
        const selectedFile = file;
        if (!selectedFile || !selectedFile.file) return;

        // check file size
        if (file.file.size > (LOGO_MAX_FILE_SIZE_IN_MB * 1024 * 1024)) {
            dispatch(toastWarn(`Exceeded size ${LOGO_MAX_FILE_SIZE_IN_MB}MB`));
            selectFile({ clear: true });
            return;
        }

        handleChange({ ...state, file, uiConfig: { ...state.uiConfig, logoUrl: file.source } });
        selectFile({ clear: true });
    }

    return (
        <div className="settings-logo">
            <div className="settings-logo-container">
                <div className="settings-logo-img">
                    <img
                        src={file ? file.source : uiConfig.logoUrl}
                        alt="app-logo" />
                </div>
            </div>
            <div className="logo-btn-container">
                <Button
                    size="sm"
                    variant="success"
                    onClick={() => selectFile({ accept: LOGO_MIME_TYPES.join(",") }, handleFileChange)}
                    className="logo-upload-btn"
                >
                    Choose File
                </Button>
                <span className="org-sub-lbl ml-2">File size should be less than 1MB</span>
            </div>
        </div>
    )
}

export default LogoUpload
